
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__like",
  "use": "icon__like-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__like\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path fill=\"currentColor\" d=\"M7.5 1.5c-3.304 0-6 2.696-6 6 0 2.877 1.53 4.647 3.446 6.293 1.921 1.647 4.265 3.322 6.445 6.358l.609.843.609-.843c2.18-3.036 4.524-4.711 6.446-6.358C20.97 12.146 22.5 10.377 22.5 7.5c0-3.304-2.695-6-6-6-1.899 0-3.41.996-4.5 2.197C10.91 2.496 9.399 1.5 7.5 1.5zm0 1.5c1.629 0 3.076.984 3.891 2.121l.609.855.609-.855C13.424 3.984 14.871 3 16.5 3 18.996 3 21 5.004 21 7.5c0 2.373-1.095 3.58-2.93 5.157-1.669 1.44-3.919 3.198-6.07 5.936-2.151-2.738-4.401-4.496-6.07-5.936C4.095 11.081 3 9.873 3 7.5 3 5.004 5.004 3 7.5 3z\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconLikeIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__like" {...restProps} />
    })
  